<template>
  <div class="problem-box" @click="$router.push({ path: '/question' })">
    <img src="@/assets/img/images/question-black.png" alt="question-black" />
    <p>{{ $t('home.footer.questions') }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.problem-box {
  cursor: pointer;
  position: fixed;
  bottom: 75px;
  right: 75px;
  width: 73px;
  height: 104px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  background: #ffffff;
  border-radius: 37px 37px 37px 37px;
  box-shadow: 0px 3px 10px 1px rgba(0, 102, 204, 0.06);
  img {
    width: 36px;
    height: 36px;
  }
  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-top: 8px;
  }
}
</style>
